<template>
  <div>
    <modal :show.sync="modals.modal1" type="medium">
      <div
        style="background-color: #f5f6fa; padding: 20px; border-radius: 20px"
      >
        <div slot="header" class="modal-title" id="modal-title-default">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-11">
                <p
                  style="
                    color: #358CCB;
                    text-align: left;
                    font-size: 24px;
                    font-weight: 300;
                  "
                ></p>
              </div>
              <div class="col-lg text-right">
                <div
                  style="
                    position: relative;
                    height: 25px;
                    width: 25px;
                    left: 50px;
                    background-color: #ea2127;
                    border-radius: 100px;
                    cursor: pointer;
                  "
                >
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="closeModal()"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12" style="padding: 10px">
          <div class="row">
            <div class="col-lg-6" v-for="(card, index) in pics" :key="index">
              <b-card
                class="card"
                border-variant="primary"
                :header="getPICTitle(index)"
                header-bg-variant="primary"
                header-text-variant="white"
                style="box-shadow: 0px 0px; border: none"
              >
                <div>
                  <p
                    style="
                      text-align: left;
                      font-size: 15px;
                      color: #A5A5A5;
                      opacity: 0.7;
                    "
                  >
                    PIC Name
                  </p>
                  <p
                    style="
                      font-size: 17px;
                      color: #5a5a5a;
                      opacity: 0.78;
                      text-align: left;
                      font-weight: 600;
                      font-size: 18px;
                      margin-top: -10px;
                    "
                  >
                    {{ card.namee }}
                  </p>
                  <p
                    style="
                      text-align: left;
                      font-size: 15px;
                      color: #A5A5A5;
                      opacity: 0.7;
                    "
                  >
                    PIC Phone No.
                  </p>
                  <p
                    style="
                      font-size: 17px;
                      color: #5a5a5a;
                      opacity: 0.78;
                      text-align: left;
                      font-weight: 600;
                      font-size: 18px;
                      margin-top: -10px;
                    "
                  >
                    {{ card.phoneno }}
                  </p>

                  <p
                    style="
                      text-align: left;
                      font-size: 15px;
                      color: #A5A5A5;
                      opacity: 0.7;
                    "
                  >
                    Email
                  </p>
                  <p
                    style="
                      font-size: 17px;
                      color: #5a5a5a;
                      opacity: 0.78;
                      text-align: left;
                      font-weight: 600;
                      font-size: 18px;
                      margin-top: -10px;
                    "
                  >
                    {{ card.email }}
                  </p>
                </div>
              </b-card>
            </div>
          </div>
        </div>

        <div
          v-if="!hidden && accessid == 1"
          class="col-lg-12"
          style="margin-bottom: 30px; text-align: right"
        >
          <base-button type="cancel" v-on:click="decline = true"
            >Decline</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="getApprove()"
            >Approve</base-button
          >
        </div>

        <div v-if="decline" class="col-lg-12">
          <p
            style="
              color: #358CCB;
              text-align: left;
              font-size: 24px;
              font-weight: 300;
            "
          >
            Comment Section
          </p>
          <p
            style="
              text-align: left;
              font-size: 15px;
              margin-top: -10px;
              color: #A5A5A5;
            "
          >
            Please add your remarks for rejection
          </p>
          <textarea
            type="textarea"
            placeholder="Write your commment..."
            v-model="reason"
            :class="{ 'custom-input-2': true }"
          ></textarea>
          <div class="d-flex justify-content-center spinner" v-if="declineload">
            <circle-8></circle-8>
          </div>
          <div class="col-lg-12" style="margin-bottom: 30px; text-align: right">
            <base-button type="danger" v-on:click="closeModal()"
              >Back</base-button
            >&nbsp;
            <base-button type="primary" v-on:click="getDecline()"
              >Submit</base-button
            >
          </div>
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.removeModal">
      <div
        class="modal-header"
        style="
          margin: -25px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #15cf79;
        "
      >
        <div class="col-lg"></div>
        <div class="col-lg-5">
          <div
            style="
              padding: 15px;
              background-color: transparent;
              border-radius: 100px;
              border: 10px solid white;
            "
          >
            <i
              style="color: white; font-size: 90px; font-weight: 900"
              class="tim-icons icon-check-2"
            ></i>
          </div>
          <div>
            <p
              style="
                color: white;
                font-size: 17px;
                text-align: center;
                font-weight: 500;
              "
            >
              Successful
            </p>
          </div>
        </div>
        <div class="col-lg"></div>
      </div>
      <div class="col-lg-12 text-center">
        <p
          style="
            margin-top: 50px;
            font-size: 40px;
            font-weight: 500;
            color: #707070;
          "
        >
          Remove File!
        </p>

        <p style="color: #A5A5A5">{{ message }}</p>

        <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <base-button type="primary" v-on:click="modals.removeModal = false"
            >Continue</base-button
          >
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.failedModal2">
      <div
        class="modal-header"
        style="
          margin: -25px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #EC1B23;
          text-align: center;
        "
      >
        <!-- <div class="col-lg"></div> -->
        <div class="col-lg-12">
          <div>
            <i
              style="color: white; font-size: 120px; font-weight: 900"
              class="tim-icons icon-alert-circle-exc"
            ></i>
          </div>
          <div>
            <p
              style="
                color: white;
                font-size: 17px;
                text-align: center;
                font-weight: 500;
              "
            >
              Failed
            </p>
          </div>
        </div>
        <div class="col-lg"></div>
      </div>
      <div class="col-lg-12 text-center">
        <p
          style="
            margin-top: 50px;
            font-size: 40px;
            font-weight: 500;
            color: #707070;
          "
        >
          Warning!
        </p>

        <p style="color: #A5A5A5">{{ message }}</p>

        <p style="color: #A5A5A5; margin-top: 20px">Click 'Retry' to go back.</p>
        <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <base-button type="danger" v-on:click="getBack()">Exit</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="closeFailedModal()"
            >Retry</base-button
          >
        </div>
      </div>
    </modal>

    <div
      class="col-lg-12"
      style="padding-top: 20px; padding-bottom: 20px"
    ></div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg"></div>
        <div class="col-lg-3 text-right">
          <!-- <base-input> -->
            <el-input
              type="search"
              class="mb-3 search-input"
              prefix-icon="el-icon-search"
              placeholder="Search..."
              v-model="searchQuery"
              aria-controls="datatables"
            ></el-input>
          <!-- </base-input> -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div id="tableku" v-if="this.load == false">
            <el-table
              :data="queriedData"
              style="width: 100%"
              height="600"
              :header-cell-style="{
                background: 'transparent',
                color: 'gray',
              }"
              class="custom-table"
            >
              <el-table-column
                :min-width="20"
                align="center"
                v-if="accessid == 1"
              >
                <div slot-scope="{ row }">
                  <div
                    v-if="row.approvalstatus == 1"
                    style="
                      border-radius: 30px;
                      width: 10px;
                      height: 10px;
                      background-color: #ff0000;
                    "
                  ></div>
                </div>
              </el-table-column>
              <el-table-column
                :min-width="50"
                align="center"
                prop="index"
                label="NO"
              >
              </el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="datereg"
                label="DATE REG."
              ></el-table-column>
              <el-table-column
                :min-width="300"
                align="center"
                prop="name"
                label="NAME"
              >
                <div slot-scope="{ row }">
                  <p class="link" @click="getModal(row)">
                    {{ row.name }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                v-for="(column, columnIndex) in afes"
                :key="column.label"
                :prop="column.prop"
                :label="column.label"
                align="center"
                :min-width="230"
                :class="{ 'clicked-row': clickedRowIndex === columnIndex }"
              >
              </el-table-column>
              <el-table-column
                :min-width="200"
                align="center"
                prop="servicelocation"
                label="SERVICE LOCATION"
              ></el-table-column>
              <el-table-column
                v-if="accessid == 2"
                :min-width="100"
                align="center"
                label="VIEW"
              >
                <div slot-scope="{ row }">
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #A5A5A5;
                      font-size: 15px;
                      font-weight: 900;
                      cursor: pointer;
                    "
                    @click="getEdit(row.id, 'preview')"
                    class="fa fa-file"
                  ></i>
                </div>
              </el-table-column>
              <el-table-column
                v-if="accessid != 2"
                :min-width="100"
                align="center"
                prop="edit"
                label="EDIT"
              >
                <div slot-scope="{ row }">
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #A5A5A5;
                      font-size: 15px;
                      font-weight: 900;
                      cursor: pointer;
                    "
                    @click="getEdit(row.id, 'edit')"
                    class="tim-icons icon-pencil"
                  ></i>
                </div>
              </el-table-column>

              <el-table-column
                v-if="accessid != 2"
                :min-width="100"
                align="center"
                prop="archive"
                label="ARCHIVE"
              >
                <div slot-scope="{ row }">
                  <i
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #A5A5A5;
                      font-size: 15px;
                      font-weight: 900;
                      cursor: pointer;
                    "
                    @click="getArchive(row.id)"
                    class="tim-icons icon-check-2"
                  ></i>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
          <!-- </card> -->
          <div
            style="padding-top: 80px"
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <!-- <base-input> -->
            <el-select
              v-model="pagination.perPage"
              placeholder="Per page"
              style="border-radius: 10px"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- </base-input> -->
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";
import { BCard } from "bootstrap-vue";

export default {
  name: "Afes",
  props: {
    tot: {
      type: Function,
    },
  },
  components: {
    BCard,
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      declineload: false,
      companyname: "",
      decline: false,
      reason: "",
      namee: "",
      id: 0,
      hidden: false,

      pics: [
        {
          name: "Haziq Haikal bin Ayub",
          phoneno: "+60195627890",
          email: "haziq@tunas.com.my",
        },
        {
          name: "Aida Yasmin Yazli",
          phoneno: "+60182297789",
          email: "aida@tunas.com.my",
        },
      ],
      cardPICCount: 2,
      message: "",
      modals: {
        modal1: false,
        modal2: false,
        removeModal: false,
        failedModal2: false,
      },
      selectedFileName: "",
      allfilename: [],
      tableDatas: [
        {
          datereg: "11-10-2022",
          name: "Yahya Abd Rahman",
          email: "yahya@afes.com",
          usertype: "Admin PIC",
          employeeno: "987 654",
          remarks: "PIC - 1",
          edit: 0,
          archive: "",
        },
        {
          datereg: "11-10-2022",
          name: "Yahya1 Abd Rahman",
          email: "yahya@afes.com",
          usertype: "Management",
          employeeno: "987 654",
          remarks: "PIC - 2",
          edit: 1,
          archive: "",
        },
        {
          datereg: "11-10-2022",
          name: "Yahya2 Abd Rahman",
          email: "yahya@afes.com",
          usertype: "Operation",
          employeeno: "987 654",
          remarks: "None",
          edit: "",
          archive: "",
        },
        {
          datereg: "11-10-2022",
          name: "Yahya3 Abd Rahman",
          email: "yahya@afes.com",
          usertype: "Admin PIC",
          employeeno: "987 654",
          remarks: "PIC - 1",
          edit: "",
          archive: "",
        },
        {
          datereg: "11-10-2022",
          name: "Yahya4 Abd Rahman",
          email: "yahya@afes.com",
          usertype: "Admin PIC",
          employeeno: "987 654",
          remarks: "PIC - 1",
          edit: "",
          archive: "",
        },
        {
          datereg: "11-10-2022",
          name: "Yahya5 Abd Rahman",
          email: "yahya@afes.com",
          usertype: "Admin PIC",
          employeeno: "987 654",
          remarks: "PIC - 1",
          edit: "",
          archive: "",
        },
      ],

      load: false,

      afes: [
        // {
        //   prop: "datereg",
        //   label: "DATE REG.",
        // },
        // {
        //   prop: "name",
        //   label: "NAME",
        // },
        {
          prop: "email",
          label: "EMAIL",
        },
        // {
        //   prop: "usertype",
        //   label: "USER TYPE",
        // },
        {
          prop: "position",
          label: "USER TYPE",
        },
        {
          prop: "employeeno",
          label: "EMPLOYEE NO.",
        },
        {
          prop: "remarks",
          label: "REMARKS",
        },
      ],

      clickedRowIndex: null,

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],
      },

      temp: [],
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 30, 50],
        total: 0,
      },

      approvalstatus: 0,
    };
  },
  methods: {
    getArchive(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        // console.log(result);
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/user-management/afes/" + id)
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                // console.log(response);
                this.message = response;
                this.modals.removeModal = true;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              } else {
                let response = res.message;
                this.message = response;
                this.modals.failedModal2 = true;
              }
            });
        }
      });
    },
    getEdit(id, flag) {
      // console.log(id);
      this.$router.push("/AddUser/afes/" + id + "/" + flag);
      //create new page
    },
    // handleRowClick(row, column, event) {
    //   this.getModal(row);
    // },
    getPICTitle(index) {
      return `PIC - ${index + 1}`;
    },
    getModal(data) {
      console.log(data);
      this.pics = [
        {
          namee: data.name,
          phoneno: data.phoneno,
          email: data.email,
        },
      ];
      // this.namee = ;
      this.id = data.id;
      this.approvalstatus = data.approvalstatus;
      this.modals.modal1 = true;
      this.checkStatus();
    },
    closeModal() {
      this.modals.modal1 = false;
    },
    getJobPage() {
      this.$router.push("/JobPage1");
    },

    getData() {
      this.load = true;

      this.tableDatas = [];

      this.$http.get(":10001/api/v1/user-management/afes").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          let count = 0;
          for (var i = 0; i < response.length; i++) {
            if (response[i].approval_status == 1) {
              count++;
            }
            let obj = {
              index:
                i +
                1 +
                this.pagination.perPage * (this.pagination.currentPage - 1),
              datereg: response[i].created_at,
              name: response[i].user_name,
              email: response[i].user_email,
              phoneno: response[i].user_phone_number,
              id: response[i].user_id,
              usertype: response[i].role_name,
              position: response[i].position_name,
              employeeno: response[i].employee_id,
              remarks: response[i].remarks,
              edit: "",
              archive: response[i].is_archived,
              approvalstatus: response[i].approval_status,
              servicelocation:
                response[i].service_location == ""
                  ? "N/A"
                  : response[i].service_location,
            };
            this.tableDatas.push(obj);
            this.temp.push(obj);
          }
          this.tot("AFES", count, this.accessid);
        }
        this.load = false;
      });
    },

    checkStatus() {
      if (this.approvalstatus == 2) {
        this.hidden = true;
        this.decline = false;
      } else if (this.approvalstatus == 3) {
        this.hidden = true;
        this.decline = true;
        //if dah submit this.decline = false;
      } else {
        this.hidden = false;
        this.decline = false;
      }
    },

    getApprove() {
      // console.log("user id", this.id);
      let obj = {
        status: 2,
      };
      this.$http
        .put(":10001/api/v1/user-management/afes/" + this.id, obj)
        .then((res) => {
          // console.log(res);
          this.modals.modal1 = false;
          this.tableDatas.forEach((data) => {
            if (data.id === this.id) {
              data.approvalstatus = 2;
            }
          });
        });
    },

    getDecline() {
      this.declineload = true;
      let obj = {
        status: 3,
        decline_remark: this.reason,
      };
      this.$http
        .put(":10001/api/v1/user-management/afes/" + this.id, obj)
        .then((res) => {
          // console.log(res);
          this.tableDatas.forEach((data) => {
            if (data.id === this.id) {
              data.approvalstatus = 3;
            }
          });

          setTimeout(() => {
            this.modals.modal1 = false;
            this.declineload = false;
          }, 2000);
          this.reason = "";
          this.decline = false;
          this.hidden = true;
        });
    },

    getReason() {
      //emailkan ke customer the reasons
      this.decline = false;
    },
  },
  created() {
    this.accessid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.getData();
    this.checkStatus();
  },
  computed: {
    filteredDataList() {
      return this.tableDatas.filter((row) => row.approval_status !== 2);
    },
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
  },
  watch: {
    searchQuery: debounce(function (search) {
      console.log(search);
      if (search != "") {
        this.tableDatas = this.temp.filter(
          (value) =>
            value.name.toLowerCase().includes(search.toLowerCase()) ||
            value.datereg.toLowerCase().includes(search.toLowerCase()) ||
            value.email.toLowerCase().includes(search.toLowerCase()) ||
            value.usertype.toLowerCase().includes(search.toLowerCase()) ||
            value.position.toLowerCase().includes(search.toLowerCase()) ||
            value.employeeno.toLowerCase().includes(search.toLowerCase()) ||
            value.servicelocation.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["datereg"],
      threshold: 1.0,
    });
  },
};
</script>
<style scoped>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.clicked-row {
  color: blue;
}

.card .card-header {
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
  font-size: 18px;
}

.custom-input-2 {
  margin: 5px 5px 15px 5px;
  border-radius: 10px;
  background-color: transparent;
  border: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

.link {
  cursor: pointer;
  color: #9b9b9b;
}
.link:hover {
  text-decoration: underline;
  cursor: pointer;
  color: #368dcc;
}
</style>
